export const types = {
    GETTING_TOKEN: 'GETTING_TOKEN',
    GET_TOKEN_SUCCESS: 'GET_TOKEN_SUCCESS',
    GET_TOKEN_FAIL: 'GET_TOKEN_FAIL',
    UPDATE_USER_INFO: 'UPDATE_USER_INFO',
    GET_OAUTH_CODE: 'GET_OAUTH_CODE',
    GET_OAUTH_CODE_SUCCESS: 'GET_OAUTH_CODE_SUCCESS'
}
